import React, { useEffect, useState } from 'react';
import './shapeGenerator.css';

type ShapeType = 'circle' | 'triangle' | 'square' | 'scribble';

interface ShapeProps {
  type: ShapeType;
  position: { x: number; y: number };
  rotation: number;
}

interface RandomShape {
  shapeType: ShapeType;
  position: { x: number; y: number };
  rotation: number;
}

const shapes: ShapeType[] = ['circle', 'triangle', 'square', 'scribble'];

const getRandomPosition = (containerWidth: number, containerHeight: number) => {
  const x = Math.floor(Math.random() * containerWidth);
  const y = Math.floor(Math.random() * containerHeight);
  return { x, y };
};
const getRandomRotation = () => {
  return Math.floor(Math.random() * 360);
}

const Shape: React.FC<ShapeProps> = ({ type, position, rotation }) => {
  return <div className={`shape ${type}`} style={{ left: position.x, top: position.y, transform: `rotate(${rotation}deg)` }}></div>;
};

export default function ShapeGenerator() {
  const [shapeList, setShapeList] = useState<RandomShape[]>([]);

  useEffect(() => {
    const container = document.querySelector('.shape-container') as HTMLElement;
    if (container) {
      const { offsetWidth: containerWidth, offsetHeight: containerHeight } = container;

      const newShapes: RandomShape[] = [];
      for (let si = 0; si < shapes.length; si++) {
        for (let i = 0; i < 3; i++) {
          const shapeType = shapes[si];
          const position = getRandomPosition(containerWidth, containerHeight);
          const rotation = getRandomRotation();
          newShapes.push({ shapeType, position, rotation });
        }
      }

      setShapeList(newShapes);
    }
  }, []);

  return (
    <div className="shape-container">
      {shapeList.map((shape, index) => (
        <Shape key={index} type={shape.shapeType} position={shape.position} rotation={shape.rotation} />
      ))}
    </div>
  );
};